import { Box, Button, Container, Paper, Toolbar, Typography } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux"
import SearchBar from "../Components/Shared/SearchBar";
import FrequencyDialog from "../Components/Frequency/FreqDialog";
import FreqTable from "../Components/Frequency/FreqTable";
import { useGetAllFrequenciesQuery } from "../Store/Services/FrequencyService";
import { closeFreqModal, openAddFreqModal } from "../Store/Slices/frequencySlice";

import styles from "./Management.module.css"

const FrequencyManagement = () => {
    const dispatch = useDispatch();
    const [searchData, setSearchData] = useState([])
    const { data, isSuccess, isLoading } = useGetAllFrequenciesQuery();


    const handleClose = () => {
        dispatch(closeFreqModal());
    }

    const roles = sessionStorage.getItem("roles");

    return (
        roles?.split(",").includes("PRIV_ES_DISPLAY_FREQUENCIES") ? (
        <Paper elevation={3} className={styles.pageContainer} style={{backgroundImage: `url(${process.env.REACT_APP_IMAGE_URL}E_SERVICE/thumbnail_Management.png)`}}>
            <Box>
                <Toolbar className={styles.subNavBar}>
                    <Typography className={styles.topic}>Frequency Management</Typography>
                    {roles?.split(",").includes("PRIV_ES_ADD_FREQUENCY") ?   (<Button variant="contained" color="primary" className={styles.buttonItem} onClick={() => dispatch(openAddFreqModal())}>Add Frequency</Button>) : null}
                </Toolbar>
            </Box>
            <Container id={styles.container}>
                <SearchBar
                    data={isSuccess || isLoading ? data : []}
                    setSearchData={setSearchData}
                    text="Search Frequencies"
                    search="freq"
                />
            </Container>

            <Container>
               {isSuccess && <FreqTable data={Array.isArray(searchData) && searchData.length > 0 ? searchData : data}/>}
            </Container>

            <FrequencyDialog handleClose={handleClose} />
        </Paper> ) : null
    )
}

export default FrequencyManagement
